import { useState } from "react";
import { Button, HStack, Text, useClipboard, Tooltip } from "@chakra-ui/react";
import { Icon } from "@equidefi/ui/icon";

const CopyableIcon = ({ text, iconSize = ".8em", iconColor = "gray", iconOnly = false, ...rest }) => {
  if (!text) return null;

  const [isHovered, setIsHovered] = useState(false);
  const { hasCopied, onCopy } = useClipboard(text);

  return (
    <HStack spacing={3} align="center" {...rest}>
      <Text fontSize="md" color="gray.700" minW={0} mb={0} isTruncated>
        {text}
      </Text>
      {iconOnly ? (
        <Tooltip label={hasCopied ? "Copied!" : "Copy"} placement="top">
          <Button
            size="sm"
            variant="ghost"
            onClick={() => {
              onCopy();
              setTimeout(() => {
                setIsHovered(false);
              }, 2000);
            }}
            color={hasCopied ? "green.500" : `${iconColor}.500`}
            minW="40px"
            width="40px"
            flexShrink={0}
            p={0}>
            {hasCopied ? <Icon.Check size={iconSize} /> : <Icon.Copy size={iconSize} />}
          </Button>
        </Tooltip>
      ) : (
        <Button
          size="sm"
          variant="ghost"
          onMouseEnter={() => !hasCopied && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            onCopy();
            setIsHovered(false);
            setTimeout(() => {
              setIsHovered(false);
            }, 2000);
          }}
          leftIcon={hasCopied ? <Icon.Check size={iconSize} /> : <Icon.Copy size={iconSize} />}
          color={hasCopied ? "green.500" : `${iconColor}.500`}
          transition="all 0.3s ease"
          width={isHovered || hasCopied ? "100px" : "40px"}
          flexShrink={0}
          justifyContent="flex-start">
          {isHovered || hasCopied ? (hasCopied ? "Copied!" : "Copy") : null}
        </Button>
      )}
    </HStack>
  );
};

export default CopyableIcon;
